import {Segment, Container, Grid, Header, Button, Form, Icon, List} from 'semantic-ui-react';
import React, {useState, useEffect} from "react";
import {ScrollRestoration} from "react-router-dom";

const Subscribe = ({is_mobile}) => {

  const [email, setEmail] = useState("")
  const [subscribed, setSubscribed] = useState(false)

  useEffect(() => {
  const submitForm = () => setSubscribed(true);
  document.querySelector("#subscribe-form").addEventListener('submit', submitForm);
  return () => {
    document.querySelector("#subscribe-form").removeEventListener('submit', submitForm);
  };
}, []);


  return (
      <>
        <Grid.Row id="grid-row-subscribe">
          <Grid.Column width={is_mobile ? null : 5}/>
          <Grid.Column width={is_mobile ? 16 : 6} verticalAlign="middle">
            <Form id="subscribe-form" action="https://tokenjobs.substack.com/api/v1/import/form/" method="post" target="_blank">
              <Form.Field
                  control="input"
                  id="subscribe-form-field"
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="Type your email here"
                  width={16}
                  name="email"
                  value={email}/>
              <input type="hidden" name="first_url" value="https://tokenjobs.io"/>
              <input type="hidden" name="current_url" value="https://tokenjobs.io"/>
              <input type="hidden" name="current_referrer" value="https://tokenjobs.io"/>
              <input type="hidden" name="source" value="embed"/>
              <Button
                  fluid
                  type="submit"
                  size="large"
                  id="apply-button"
                  primary
                  disabled={subscribed}
                  >
                {subscribed ? "Subscribed!" : "Subscribe"}
              </Button>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </>
  )
}

const Footer = (props) =>  {

  return (
     <Segment id='segment-header-footer' inverted vertical>
       <Container text>
        <Grid inverted>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <Header inverted as="h3" >Join our newsletter and don't miss any jobs!</Header>
            </Grid.Column>
          </Grid.Row>
          <Subscribe is_mobile={props.is_mobile}/>


          {!props.is_mobile && <Grid.Column width={5} floated="left"/>}

          <Grid.Column width={props.is_mobile ? 16 : 6}>
            <hr className="footer-divider" />

            <Grid>
              <Grid.Row>
                <Grid.Column width={8} style={props.is_mobile ? {paddingLeft: "3.3rem"} : {}}>
                  <Header textAlign="left" style={{color: "yellow"}} inverted as='h4' content='Roles' />
                  <List className="footer-categories" link>
                    <List.Item href="/internship" as="a">Internships</List.Item>
                    <List.Item href="/sales" as="a">Sales</List.Item>
                    <List.Item href="/marketing" as="a">Marketing</List.Item>
                    <List.Item href="/trading" as="a">Trading</List.Item>
                    <List.Item href="/engineering" as="a">Engineering</List.Item>
                    <List.Item href="/design" as="a">Design</List.Item>
                    <List.Item href="/remote" as="a">Remote</List.Item>
                    <List.Item href="/part-time" as="a">Part-Time</List.Item>
                    <List.Item href="/freelance" as="a">Freelance</List.Item>
                    <List.Item href="/social-media" as="a">Social Media</List.Item>
                    <List.Item href="/companies/Polymarket" as="a">Polymarket Jobs</List.Item>
                  </List>
                </Grid.Column>
                <Grid.Column width={8} style={props.is_mobile ? {paddingLeft: "3.3rem"} : {}}>
                  <Header textAlign="left" style={{color: "yellow"}} inverted as='h4' content='Categories' />
                  <List className="footer-categories" link>
                    <List.Item href="/web3-jobs" as="a">Web3 Jobs</List.Item>
                    <List.Item href="/nft" as="a">NFT Jobs</List.Item>
                    <List.Item href="/defi" as="a">Defi Jobs</List.Item>
                    <List.Item href="/solidity" as="a">Solidity Jobs</List.Item>
                    <List.Item href="/bitcoin" as="a">Bitcoin Jobs</List.Item>
                    <List.Item href="/ethereum" as="a">Ethereum Jobs</List.Item>
                    <List.Item href="/solana" as="a">Solana Jobs</List.Item>
                    <List.Item href="/cosmos" as="a">Cosmos Jobs</List.Item>
                    <List.Item href="/unity" as="a">Unity Jobs</List.Item>
                    <List.Item href="/exchange" as="a">Exchange Jobs</List.Item>
                    <List.Item href="/companies/Hyperliquid" as="a">Hyperliquid Jobs</List.Item>
                  </List>
                </Grid.Column>
              </Grid.Row>
            </Grid>

          </Grid.Column>

          {!props.is_mobile && <Grid.Column width={5} floated="right"/>}

          <Grid.Row>
            <Grid.Column textAlign='center' style={{marginTop: '1em'}}>
              <p id="footer-message">One spot for all web3 opportunities. </p>
              <p>© 2025 token jobs
                <a className="footer-twitter" href="https://www.twitter.com/tokenjobs" aria-label="Follow us on twitter for more job updates">
                  <Icon color="blue" name="twitter"/>
                </a>
                <a className="footer-twitter" href="https://www.linkedin.com/company/token-jobs/" aria-label="Follow us on linkedin for more web3 related content">
                  <Icon color="blue" name="linkedin"/>
                </a>
                <a className="footer-twitter" href="https://www.facebook.com/people/Token-Jobs/61553465815464/" aria-label="Follow us on facebook to see more crypto opportunities">
                  <Icon color="blue" name="facebook"/>
                </a>
                <a className="footer-twitter" href="https://medium.com/@tokenjobsio/web3-job-update-2023-968407ecda28" aria-label="Follow us on medium to see get updates on crypto opportunities">
                  <Icon color="blue" name="medium"/>
                </a>
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
       </Container>
     </Segment>
  )
}

export default Footer;